
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M23.866 23.782c-.832.81-.87 1.984-.093 2.771.787.797 1.958.803 2.794.013.819-.771.858-2.006.086-2.79-.768-.787-1.971-.787-2.787.006zM3.059 9.555c-.397.416-.406 1.021-.022 1.398a.994.994 0 001.363.006c.4-.387.4-1.075 0-1.446-.394-.368-.96-.352-1.341.042zM9.44 3.13c-.374.368-.394.982-.042 1.35.349.365 1.034.371 1.418.016.378-.349.39-1.043.026-1.411-.371-.368-.995-.349-1.402.045zM7.485 26.045a.951.951 0 00.022 1.347c.41.387 1.021.39 1.402.006a.952.952 0 00-.003-1.347c-.419-.432-1.014-.435-1.421-.006zM25.958 7.45a.966.966 0 00.013 1.392.968.968 0 001.354.003c.378-.378.371-1.021-.013-1.405a.965.965 0 00-1.354.01zM2.314 18.589a.958.958 0 00-.006 1.386c.384.384.963.394 1.344.019.384-.374.39-1.021.013-1.405-.355-.362-.982-.362-1.35 0zm27.388-2.4c-.387-.371-1.014-.342-1.389.064-.368.397-.349.957.045 1.338.374.365.982.365 1.35 0s.368-1.043-.006-1.402zM16.266 28.378c-.378.39-.374.966.01 1.341.384.378 1.04.374 1.402-.01a.975.975 0 00-.026-1.357c-.4-.39-.992-.381-1.386.026zm2.208-26.08a.98.98 0 00.01 1.354c.378.384 1.03.381 1.395-.006a.971.971 0 00-.064-1.386.943.943 0 00-1.341.038z"}})])
          )
        }
      }
    